module.exports = __webpack_public_path__ + "static/media/dummy256x256.362e6fd8.png";